import PropTypes from 'prop-types'
import React from 'react'

import SimpleIcon from './SimpleIcon'

const NavbarUpButton = ({ icon, onClick }) => (
  <button
    className='navbar-button navbar-button-left navbar-button-up qa-nav-up'
    type='button'
    onClick={onClick}
  >
    <SimpleIcon icon={icon} />
  </button>
)

NavbarUpButton.propTypes = {
  onClick: PropTypes.func.isRequired,
  icon: PropTypes.oneOfType([PropTypes.string, PropTypes.object]).isRequired
}

export default NavbarUpButton
